import { useNavigate } from 'react-router-dom';

export const useHeaderAnalyze = (
  loading,
  progressModal,
  globalCopyModal,
  handleAnalyze,
  handleGlobalCopyNavigation
) => {
  const navigate = useNavigate();

  const handleHeaderAnalyze = async () => {
    // ✅ 중복 클릭 방지 (분석페이지에서는 progressModal 사용)
    if (loading || progressModal.open || globalCopyModal.open) {
      console.log('🚫 [AnalyzePage] 이미 진행 중인 작업이 있습니다');
      return;
    }

    const result = await handleAnalyze();
    
    // ✅ 광역 복사 네비게이션 처리
    if (handleGlobalCopyNavigation(result)) {
      return;
    }
    
    // 일반 분석인 경우 바로 이동
    if (result && result.historyId) {
      navigate(`/analyze/${result.historyId}`, { replace: true });
    }
  };

  return {
    handleHeaderAnalyze
  };
}; 